// extracted by mini-css-extract-plugin
export default {"modalBody":"userJourneyCard_modalBody__bTGMp","leftAlignTitle":"userJourneyCard_leftAlignTitle__BjN3P","userJourneyContent":"userJourneyCard_userJourneyContent__l0E5I"};